/* eslint-disable @typescript-eslint/no-explicit-any */
import { Navigate } from "react-router";
import { useContext, Suspense } from "react";

// Context & Spinner
import { AbilityContext } from "@src/utility/context/Can";
import Spinner from "../spinner/Loading-spinner";

const PrivateRoute = ({ children, route }: any) => {
  const ability: any = useContext(AbilityContext);
  
  // ✅ Direct localStorage check - no loading state needed
  const getUserFromStorage = () => {
    try {
      const userData = localStorage.getItem("userData");
      if (userData && userData !== "null" && userData !== "") {
        return JSON.parse(userData);
      }
      return null;
    } catch (error) {
      console.error("❌ PrivateRoute error parsing userData:", error);
      return null;
    }
  };

  const user = getUserFromStorage();

  if (route) {
    let action = null;
    let resource = null;
    let restrictedRoute = false;

    if (route.meta) {
      action = route.meta.action;
      resource = route.meta.resource;
      restrictedRoute = route.meta.restricted;
    }

    // 1. Not logged in
    if (!user) {
      return <Navigate to="/login" replace />;
    }

    // 2. Restricted route logic
    if (user && restrictedRoute) {
      return <Navigate to="/" replace />;
    }

    // 3. Optional role-based restrictions
    if (user && restrictedRoute && user.roleName === "client") {
      return <Navigate to="/access-control" replace />;
    }

    // 4. Permission check only when route defines a resource to guard
    // if (
    //   user.roleName?.toLowerCase() !== "super admin" &&
    //   !route?.skipAbilityCheck &&
    //   resource &&
    //   ability &&
    //   !ability.can(action || "read", resource)
    // ) {
    //   return <Navigate to="/misc/not-authorized" replace />;
    // }
  }

  return (
    <Suspense fallback={<Spinner className="content-loader" />}>
      {children}
    </Suspense>
  );
};

export default PrivateRoute;